import React, { useMemo, useCallback, useState } from "react";
import Modal from "react-modal";
import { marked } from "marked";

import { QUESTION_TYPE_IDS, EMPTY_STRING, SAVE } from "../../../../constants";
import RichTextEditor from "../../../../shared/components/Editor/RichTextEditor";
import DetailRow from "./DetailRow";
import { eventBookingActions } from "../../../../redux/actions";
import { connect } from "react-redux";

// Modal for showing the details of reels (recap brief)
const EventDetailsModal = ({
  className,
  eventDetail,
  eventDetailId,
  isModalOpen,
  handleModalClose,
  updateEventShotList,
  isShotListEditable = false,
}) => {
  // Convert markdown/plain text into HTML.
  // Detects if HTML already exists to avoid double-parsing.
  const getFormattedHtml = (text = "") => {
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);

    return {
      __html: isHtml ? text : marked.parse(text),
    };
  };

  const initialShotListContent = useMemo(() => {
    const description = eventDetail?.eventType?.description || EMPTY_STRING;
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(description);
    return description
      ? isHtml
        ? description
        : marked.parse(description)
      : EMPTY_STRING;
  }, [eventDetail]);

  const eventTypeId = useMemo(() => {
    return eventDetail?.eventType?.id || null;
  }, [eventDetail]);

  const [currentContent, setCurrentContent] = useState(initialShotListContent);

  // Convert markdown/plain text into HTML once per eventDetail change.
  // Detects if HTML already exists to avoid double-parsing.

  const handleContentChange = useCallback((content) => {
    setCurrentContent(content);
  }, []);

  const handleSave = useCallback(async () => {
    if (!eventTypeId) return;

    await updateEventShotList({
      eventTypeId: eventTypeId,
      description: currentContent,
    });
    handleModalClose();
  }, [eventTypeId, currentContent, handleModalClose]);

  return (
    <Modal
      isOpen={isModalOpen}
      className={className}
      onRequestClose={handleModalClose}
    >
      <div className="main-con">
        <div className="row">
          {/* Header */}
          <div className="row w-100 header">
            <div className="col-12">shot list</div>
            <div className="col-12">{eventDetailId}</div>
          </div>
          {/* Details */}
          <div className="w-100 my-3">
            <>
              <DetailRow
                label="event type:"
                value={eventDetail?.eventType?.name}
              />
              <DetailRow
                label="event overview:"
                value={
                  eventDetail?.eventQuestionAnswers?.find(
                    (f) => f.questionTypeId == QUESTION_TYPE_IDS.CONTENT_USAGE
                  )?.answer ?? " "
                }
              />
              {/* shot list (Markdown + HTML Support) */}
              <div className="row w-100">
                <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 detail-row-heading">
                  event shot list:
                </div>
                {isShotListEditable ? (
                  <div className="event-shot-list-editor">
                    <RichTextEditor
                      onContentChange={handleContentChange}
                      initialContent={initialShotListContent}
                    />
                  </div>
                ) : (
                  <div
                    className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                    dangerouslySetInnerHTML={getFormattedHtml(
                      initialShotListContent
                    )}
                  />
                )}
              </div>
              <DetailRow
                label="brand & legal requirements:"
                value={
                  eventDetail?.eventQuestionAnswers?.find(
                    (f) =>
                      f.questionTypeId == QUESTION_TYPE_IDS.BRAND_GUIDELINES
                  )?.answer ?? " "
                }
              />
            </>
          </div>
        </div>
        {isShotListEditable && (
          <div className="d-flex justify-content-center w-100 mt-3">
            <button
              type="button"
              className="button-common button-fill"
              onClick={handleSave}
            >
              {SAVE}
            </button>
          </div>
        )}
        <button onClick={handleModalClose} className="modal-close">
          <img
            alt="crossIcon"
            className="modal-close-img"
            src="/images/simpleCrossWhite.svg"
          />
        </button>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateEventShotList: (data) =>
    dispatch(eventBookingActions.updateShotList(data)),
});

export default connect(null, mapDispatchToProps)(EventDetailsModal);
